<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-userentrydates-presenters
    [entryDates]="entryDates"
    [groups]="groups"
    [entryEndDate]="entryEnd"
    [entryStartDate]="entryStart"
    [process]="process$ | async"

    [selectedError]="selectedError$ | async"
    (ShowError)="this.ShowError.next($event)"
    (SaveEntryDates)="onSaveEntryDates($event)"
    (MultiSaveEntryDates)="onMultiSaveEntryDates($event)"
>
</ef-userentrydates-presenters>
<!-- [errors]="errors$ | async" -->
